import Events from '../../utilities/EventEmitter';
import { APP_EVENT_NAMES } from '../constants';

export const notificationUpdated = () => {
  Events.emit(APP_EVENT_NAMES.DEFAULT.UpdateNotifications);
};
